import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import avatar from '../../Pics/avatar.jpg'

import SpecificComponent from '../SpecificComponent'
import { Fab, FormControl, InputLabel, Select, MenuItem, Input, Grid, Checkbox, Avatar } from '@material-ui/core';
import Utils from '../../providers/Utils';
import PropTypes from 'prop-types';
import Ws from '../../providers/Ws';
import OpenAddFisaPostului from './OpenAddFisaPostului';
import OpenAddCV from './OpenAddCV';


export default class AdminBeneficiarEdit extends SpecificComponent {

    constructor(props) {
        super(props)
        this.state = {

        }
    }

    //fisaPost adresaMedia + /Angajati/FisePost







    render() {
        return (
            <div>
                <Dialog
                    open={this.props.open}
                    onClose={this.props.dialogClose}
                    fullWidth={true}
                    maxWidth={'md'}
                    style={{
                        zIndex: 5000,
                    }}
                >

                    <DialogActions>
                        <Fab onClick={this.props.dialogClose} className="pm-round-button-dialog">
                            <i className='material-icons pm-round-button-text-dialog'>clear</i>
                        </Fab>
                    </DialogActions>

                    <h2 style={{ marginBottom: 5 }} className="pm-title">{this.props.admin.nume}</h2>



                    <DialogContent style={{ width: '90%', margin: 'auto', overflow: 'hidden' }}>
                        <Grid style={{ width: '90%', margin: 'auto' }} container >


                            <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                                <TextField
                                    className="inputFocus loginTextField"
                                    style={{ width: '90%' }}
                                    label={this.props.limba.clienti.nume}
                                    value={this.props.admin.nume || ''}
                                    onChange={this.props.changeAdmin('nume')}
                                    margin="normal"
                                    type='text'
                                />

                            </Grid>
                            <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                                <TextField
                                    className="inputFocus loginTextField"
                                    style={{ width: '90%' }}
                                    label={this.props.limba.clienti.adresa}
                                    value={this.props.admin.adresa || ''}
                                    onChange={this.props.changeAdmin('adresa')}
                                    margin="normal"
                                    type='text'
                                />

                            </Grid>

                            <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                                <TextField
                                    className="inputFocus loginTextField"
                                    style={{ width: '90%' }}
                                    label={this.props.limba.clienti.oras}
                                    value={this.props.admin.oras || ''}
                                    onChange={this.props.changeAdmin('oras')}
                                    margin="normal"
                                    type='text'
                                />

                            </Grid>
                            <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                                <TextField
                                    className="inputFocus loginTextField"
                                    style={{ width: '90%' }}
                                    label={this.props.limba.clienti.nationalitate}
                                    value={this.props.admin.nationalitate || ''}
                                    onChange={this.props.changeAdmin('nationalitate')}
                                    margin="normal"
                                    type='text'
                                />

                            </Grid>
                            <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                                <TextField
                                    className="inputFocus loginTextField"
                                    style={{ width: '90%' }}
                                    label={this.props.limba.clienti.limba}
                                    value={this.props.admin.limba || ''}
                                    onChange={this.props.changeAdmin('limba')}
                                    margin="normal"
                                    type='text'
                                />

                            </Grid>


                            <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                                <FormControl className='inputFocus' style={{ width: '90%', marginTop:16 }}>
                                    <InputLabel htmlFor="resursa">{this.props.limba.clienti.educatie}</InputLabel>
                                    <Select

                                        value={this.props.admin.educatie || ""}
                                        onChange={this.props.changeAdmin('educatie')}

                                        input={<Input id="resursa" />}>


                                        {this.props.tipuriEducatie.map((s, idx) => {
                                            return <MenuItem value={s} key={idx}  > {s}</MenuItem>

                                        })
                                        }
                                    </Select>
                                </FormControl>

                            </Grid>
                            <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                                <TextField
                                    className="inputFocus loginTextField"
                                    style={{ width: '90%' }}
                                    label={this.props.limba.clienti.clasaSociala}
                                    value={this.props.admin.clasa_sociala || ''}
                                    onChange={this.props.changeAdmin('clasa_sociala')}
                                    margin="normal"
                                    type='text'
                                />

                            </Grid>

                            <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                            <FormControl className='inputFocus' style={{ width: '90%', marginTop:16 }}>
                                    <InputLabel htmlFor="resursa">{this.props.limba.clienti.sex}</InputLabel>
                                    <Select

                                        value={this.props.admin.sex || ""}
                                        onChange={this.props.changeAdmin('sex')}

                                        input={<Input id="resursa" />}>


                                        {['M','F'].map((s, idx) => {
                                            return <MenuItem value={s} key={idx}  > {s}</MenuItem>

                                        })
                                        }
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                                <TextField
                                    className="inputFocus loginTextField"
                                    style={{ width: '90%' }}
                                    label={this.props.limba.clienti.religie}
                                    value={this.props.admin.religie || ''}
                                    onChange={this.props.changeAdmin('religie')}
                                    margin="normal"
                                    type='text'
                                />

                            </Grid>

                            <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                                <TextField
                                    className="inputFocus loginTextField"
                                    style={{ width: '90%' }}
                                    label={this.props.limba.clienti.rasa}
                                    value={this.props.admin.rasa || ''}
                                    onChange={this.props.changeAdmin('rasa')}
                                    margin="normal"
                                    type='text'
                                />

                            </Grid>

                            <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                                <TextField
                                    className="inputFocus loginTextField"
                                    style={{ width: '90%' }}
                                    label={this.props.limba.clienti.nrMembriiFamilie}
                                    value={this.props.admin.nr_membrii_familie || ''}
                                    onChange={this.props.changeAdmin('nr_membrii_familie')}
                                    margin="normal"
                                    type='text'
                                />

                            </Grid>

                            <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                                <TextField
                                    className="inputFocus loginTextField"
                                    style={{ width: '90%' }}
                                    label={this.props.limba.clienti.ocupatie}
                                    value={this.props.admin.ocupatie || ''}
                                    onChange={this.props.changeAdmin('ocupatie')}
                                    margin="normal"
                                    type='text'
                                />

                            </Grid>

                            <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                            <FormControl className='inputFocus' style={{ width: '90%', marginTop:16 }}>
                                    <InputLabel htmlFor="resursa">{this.props.limba.clienti.stilViata}</InputLabel>
                                    <Select

                                        value={this.props.admin.stil_de_viata || ""}
                                        onChange={this.props.changeAdmin('stil_de_viata')}

                                        input={<Input id="resursa" />}>


                                        {new Utils().stiluriViata.map((s, idx) => {
                                            return <MenuItem value={s} key={idx}  > {s}</MenuItem>

                                        })
                                        }
                                    </Select>
                                </FormControl>

                            </Grid>

                            <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                                <TextField
                                    className="inputFocus loginTextField"
                                    style={{ width: '90%' }}
                                    label={this.props.limba.clienti.venit}
                                    value={this.props.admin.venit || ''}
                                    onChange={this.props.changeAdmin('venit')}
                                    margin="normal"
                                    type='text'
                                />

                            </Grid>

                            <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                                <TextField
                                    className="inputFocus loginTextField"
                                    style={{ width: '90%' }}
                                    label={this.props.limba.clienti.note}
                                    value={this.props.admin.note || ''}
                                    onChange={this.props.changeAdmin('note')}
                                    margin="normal"
                                    multiline
                                    type='text'
                                />

                            </Grid>




                        </Grid>

                    </DialogContent>

                    <DialogActions>

                        <div style={{ margin: 'auto' }}>
                            <Button variant="outlined" onClick={this.props.updateAdmin} className='pm-save-button'>
                                {this.props.limba.comune.save}
                            </Button>


                        </div>

                    </DialogActions>

                </Dialog>






            </div>

        );
    }


}  // end class

AdminBeneficiarEdit.propTypes = {
    open: PropTypes.bool,
    dialogClose: PropTypes.func,
    objUser: PropTypes.object,
    limba: PropTypes.object,
    cost: PropTypes.object,
    changeCost: PropTypes.func,
    updateCost: PropTypes.func,



}